<template>
  <div>
    <section class="c-page-header">
      <div class="c-page-header__left">
        <h1 class="c-page-header__left-title">{{ heading }}</h1>
      </div>

      <div class="c-page-header__right">
        <div class="c-rewards-navigation">
          <button
            class  = "c-button qa-filter-modal-button"
            :class = "{ 't-button-secondary': filtersApplied, 't-button-transparent': !filtersApplied  }"
            @click = "toggleFilterModal"
          >
            {{ $t('web.catalog_rewards_navigation.filters_button') }} <i class="fa fa-sliders c-button__icon"></i>
          </button>
        </div>
      </div>
    </section>


    <!-- Use v-show so the categories load when the page loads. -->
    <rewards-filter-modal
      v-show = "showFilterModal"
      @close = "toggleFilterModal"
    ></rewards-filter-modal>
  </div>
</template>




<script>
import { clone, get, find } from 'lodash'
import RewardsFilterModal from '@/views/components/catalog/RewardsFilterModal'
import { mapGetters } from 'vuex'

export default {
  name: 'RewardsNavigation',

  components: { RewardsFilterModal },

  data () {
    return {
      showFilterModal: false
    }
  },

  computed: {
    ...mapGetters([
      'participant'
    ]),

    /**
     * Check to see if any filters are applied.
     *
     * @return {boolean}
     */
    filtersApplied () {
      // Create a copy of the query params minus keys not considered part of filters.
      const appliedFilters = clone(this.$route.query)
      delete appliedFilters.page
      delete appliedFilters.search

      return Boolean(Object.keys(appliedFilters).length)
    },

    /**
     * Determine the appropriate heading for the page.
     *
     * @return {string}
     */
    heading () {
      return get(
        find(
          get(this.$store.getters, 'categories', []),
          category => category.code === this.$route.query.category
        ),
        'name.' + this.participant.catalog_locale,
        this.$t('web.catalog_rewards_navigation.no_category_title')
      )
    }
  },

  methods: {
    /**
     * Toggle the visibility of the filter modal.
     *
     * @return {void}
     */
    toggleFilterModal () {
      document.querySelector('body').classList.toggle('has-modal')
      this.showFilterModal = !this.showFilterModal
    }
  }
}
</script>



// WEBPACK FOOTER //
// RewardsNavigation.vue?04c04910